import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {localization} from '../../Frames/localization'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
    });
  
  function Data(props)
  {
  //if(props.data.cardConsumptionAmountCounters === null) return [];
   var rows = 
      props.data.cardConsumptionAmountCounters.map(item => (
        createData(item.cardCode, item.externalCardCode, item.currentMonthSkuQuantity, item.currentMonth, item.lastMonthSkuQuantity, item.lastMonth)
      ))
  
    return rows;
  }
  function createData(cardCode, externalCardCode, presentMonth_L, presentMonth_money, pastMonth_L, pastMonth_money) {
    return { cardCode, externalCardCode, presentMonth_L, presentMonth_money, pastMonth_L, pastMonth_money };
  }
  
  
  
  export default function SimpleTable(props) {
    const classes = useStyles();

    const rows = Data(props)
    var tr = {
      Card: localization.GetTranslate('Statistics.Card'),
      Total: localization.GetTranslate('Statistics.Total'),
      Previous_month: localization.GetTranslate('Statistics.Previous month'),
      This_month: localization.GetTranslate('Statistics.This month'),
      All_the_time: localization.GetTranslate('Statistics.All the time'),
      checks: localization.GetTranslate('Statistics.checks')
    }
    return (
        <div className={props.className}>
                <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                    <TableCell>{tr.Card}</TableCell>
                    <TableCell align="center">{tr.This_month},&nbsp;л</TableCell>
                    <TableCell align="center">{tr.This_month},&nbsp;грн</TableCell>
                    <TableCell align="center">{tr.Previous_month},&nbsp;л</TableCell>
                    <TableCell align="center">{tr.Previous_month},&nbsp;грн</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>              
                    {rows.map(row => ( 
                    row.cardCode &&
                    <TableRow key={row.cardCode}>                 
                        <TableCell component="th" scope="row">{row.externalCardCode.replace("null","-")}</TableCell>
                        <TableCell align="center">{row.presentMonth_L}</TableCell>
                        <TableCell align="center">{row.presentMonth_money}</TableCell>
                        <TableCell align="center">{row.pastMonth_L}</TableCell>
                        <TableCell align="center">{row.pastMonth_money}</TableCell>
                    </TableRow>
                    ))}
                     {rows.map(row => (
                    row.cardCode == null &&
                    <TableRow>
                        <TableCell component="th" scope="row">{tr.Total}</TableCell>
                        <TableCell align="center">{row.presentMonth_L}</TableCell>
                        <TableCell align="center">{row.presentMonth_money}</TableCell>
                        <TableCell align="center">{row.pastMonth_L}</TableCell>
                        <TableCell align="center">{row.pastMonth_money}</TableCell>
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
      </div>
    );
  }